import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import { STATES } from '../../util/states';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-state-listing',
  templateUrl: './state-listing.component.html',
  styleUrls: ['./state-listing.component.scss']
})
export class StateListingComponent {
  STATES = STATES;

  constructor(
    private _meta: Meta,
    private _title: Title
  ) {
    this._title.setTitle(`Airports by State - ${environment.appName}`);
    this._meta.removeTag('name="description"');
  }

  getStateName(state: string): string {
    return state.substring(0, state.length - 5);
  }
}
